import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNucleoComponent } from './simple-icons-nucleo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNucleoComponent ],
    exports:      [ SimpleIconsNucleoComponent ],
    bootstrap:    []
})
export class SimpleIconsNucleoModule {}
